import Navbar from "react-bootstrap/esm/Navbar";
import "../styling/NavBar.css";

export default function SignUpForm() {
  return (
    //this is the navigation bar
    <Navbar expand="lg">
      <Navbar.Brand className="navCustom" href="https://www.sotira.co/about">
        About
      </Navbar.Brand>
      <Navbar.Brand className="navCustom" href="https://www.sotira.co/blog">
        Blog
      </Navbar.Brand>
      <Navbar.Brand className="navCustom" href="https://www.sotira.co/contact">
        Contact
      </Navbar.Brand>
      <Navbar.Brand className="navCustom-signup" href="/auth/register">
        Sign Up
      </Navbar.Brand>
    </Navbar>
  );
}
